import React  , { Component } from 'react'

import {  HomeSlider,
          HomeTitle,
          Img       } from '../../Components/UI/UI'

import { getWeather, asyncgetWeather } from "../../Utility/Utility";

import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'

import "./CoronaVirus.css"

class CoronaVirus extends Component {

  state = {
   
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,

  }

  componentDidMount () {
   
    Promise.all([ asyncgetWeather() ]).then( response => {
      const weather = response[0];
        this.setState({
          jerusalemWeather  : weather.jerusalem.temperature,
          telAvivWeather    : weather.telaviv.temperature,
          waterTemp         : weather.telaviv.water_temp
        })
    });
  
    window.addEventListener("resize", this.updateDimensions);
  }
  
  render(){
    return(
      <div className="page align-left page-Corona-virus">
        <Menu />
          <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />
            
            <div className="container">
             
             

            
            
          <p>Under dessa utmanande tider står vi i Israel enade tillsammans med er, det svenska folket, och erbjuder er våra böner och vårt stöd, förenade i hopp om en ljusare och bättre morgondag.</p>
               

            {/*  <h1>RESEVARNINGAR OCH SÄKERHETSINFORMATION FRÅN ISRAELISKA STATEN</h1>*/}

              <h2 className="ac-pink">SENASTE INFORMATIONEN OM CORONAVIRUSET FÖR TURISTER I ISRAEL (COVID-19):</h2>
             
            {/*  <h2 className="ac-pink">Israel tillkännager ytterligare öppningar av samhället</h2>

            <p>Från och med den 1 juni tillkännagav Israels hälsoministerium ytterligare öppningar av samhället, bland dem öppnandet av restauranger, turistattraktioner och hotell. Stränderna öppnades 20 maj.</p>

            <p>Från den 27 maj 2020 får restauranger, barer, pubar och klubbar öppna, med vissa begränsningar. Fritids- och turistattraktioner som hotell, museer och simbassänger får också öppna, med vissa begränsningar.</p>

            <p>Hälsoministeriet har också enats om att öka buss- och taxipassagerarnas kapacitet, samt att återuppta tågaktivitet, från 8 juni.</p>

            <p>Underhållning och fritidsaktiviteter kommer att återupptas den 14 juni, inklusive evenemangsplatser och trädgårdar, konserter, teatrar, biograf, konst- och kulturevenemang, med vissa begränsningar.</p>

            <p>Inom turistsektorn har flera länder kunnat öppna sina gränser för israeliska medborgare: Grekland, Österrike, Montenegro, Georgien och nu Cypern (med början den 9 juni).</p>

            <p>Internationella flygbolag som Delta Airlines, British Airways, Air Canada, Wizz Air, Ryanair, Lufthansa, Turkish Airlines, Alitalia, Ukrainian International med mera har meddelat sin avsikt att återuppta kommersiella flygningar till och från Israel i sommar.</p>*/}

            <h2 className="ac-pink ac-margin-top-1 ac-bigger">Turister som planerar<br className="show-on-mobile"/> att resa till Israel:</h2>

            <p>För tillfället, och tills vidare, kommer alla som inte är invånare i Israel eller israeliska medborgare att nekas inträde i landet oavsett varifrån man reser. I undantagsfall kan man ansöka om utrikesministeriets godkännande om att få resa in i landet, men man måste då kunna intyga att man kommer isolera sig i 14 dagar.</p>

            <h2 className="ac-pink ac-margin-top-1 ac-bigger">Allmänna riktlinjer för alla som befinner sig i Israel</h2>
            
            <ul>
              <li>
                Var god besök hälsoministeriets <a href="https://govextra.gov.il/ministry-of-health/corona/corona-virus-en/" target="_blank">hemsida</a> för den senaste informationen om fall av coronavirus i Israel.
              
              </li>
            </ul>
            
            <ul>
              <li>
                Om du får feber som motsvarar eller överstiger 38°C, hosta, andningssvårigheter eller andra andningsrelaterade symtom, <strong>måste du omedelbart isolera dig och ringa 101 MDA Gemener Emergency Services Hotline för medicinsk rådgivning.</strong>
              </li>
              <li>
                Den israeliska regeringen övervakar utbrottet noggrant och har vidtagit tillfälliga åtgärder, inklusive inträdesrestriktioner som omfattar resenärer från hela världen.
              </li>
              <li>
                Personer som uppvisar symtom får inte vistas kring patienter eller besöka äldreboenden.
              </li>
            </ul>

            <h2 className="ac-pink ac-margin-top-1 ac-bigger">Viktigt!</h2>
            
            <ul>
              <li>
                Om självisolering bedöms vara nödvändigt för dig 
                <strong className="ac-pink">måste du rapportera det till hälsoministeriet: <a href="https://www.govforms.gov.il">www.govforms.gov.il</a></strong>
              </li>
              <li>
                Om du får feber som motsvarar eller överstiger 38°C, hosta, andningssvårigheter eller andra andningsrelaterade symtom,
                <strong className="ac-pink">måste du omedelbart isolera dig och ringa 101 MDA Gemener Emergency Services Hotline för medicinsk rådgivning.</strong>
              </li>
              <li>
                <strong className="ac-pink">• Det är absolut förbjudet att vistas inne på kliniker eller sjukhus om du uppvisar något av ovanstående symtom!</strong>
              </li>
            </ul>

            <h2 className="ac-pink ac-margin-top-1 ac-bigger">Vanliga frågor</h2>

            <h2 className="ac-pink ac-margin-top-1 ac-bigger">Jag är turist i Israel och misstänker att jag kan ha COVID-19. Var ska jag vända mig?</h2>

            <p>Om du får feber som motsvarar eller överstiger 38°C, hosta, andningssvårigheter eller andra andningsrelaterade symtom, måste du omedelbart isolera dig och ringa 101 MDA Emergency Services Hotline för medicinsk rådgivning. <strong className="ac-pink">Gå inte till en HMO-klinik eller akutmottagning.</strong></p>
            
            <p><strong className="ac-pink">När kommer Israel att öppna sina gränser för besökare igen?</strong></p>
            
            <p>Inget datum har för närvarande fastställts då Israel kommer öppna sina gränser för besökare.</p>
            
            <h2 className="ac-pink ac-margin-top-1 ac-bigger">
              BILDÖVERSÄTTNING:<br/>
              Hur kan man minska risken för att få en virusinfektion?
            </h2>

            <p>Tvätta händerna Tvätta händerna ofta med tvål och vatten innan du äter, innan du hanterar mat, efter toalettbesök, efter kontakt med kroppsvätskor, efter att du hostat eller nyst och efter att du har berört använt pappersnäsduk.</p>

            <h2 className="ac-pink ac-margin-top-1 ac-bigger">
              Täck din mun och näsa<br/>
              när du hostar eller nyser
            </h2>

            <p>Täck mun och näsa med pappersnäsduk, inte med dina händer, och släng sedan det använda pappersnäsduk i soporna</p>
            
            <p>Om pappersnäsduk inte finns tillgängligt täck då näsan med ärmen; på det här sättet kan risken att smitta andra som berör delade ytor minimeras</p>
            
            <h2 className="ac-pink ac-margin-top-1 ac-bigger">
              Stanna hemma om du är sjuk
            </h2>
            
            <p>Stanna hemma om du upplever symtom; låt inte barn med symtom vistas på dagis</p>
            
            <h2 className="ac-pink ac-margin-top-1 ac-bigger">
              Undvik kollektivtrafik
            </h2>
            
            <p>Om du är sjuk eller har symtom</p>
   

      
        




          <Img desktopImg={"infection.jpg"} />

          </div>

          
        <Footer />
      </div>
    )
    }

}



export default CoronaVirus


// WEBPACK FOOTER //
// ./src/Pages/CoronaVirusPage/CoronaVirusSE.js